<script>
import { mapMutations } from 'vuex'
export default {
  name: 'StudentNotesTab',
  data () {
    return {
      studentForm: this.$store.state.students.studentForm
    }
  },
  methods: {
    ...mapMutations('students', [
      'updateStudentForm'
    ])
  }
}
</script>

<template>
  <div class="layout-padding">
    <q-field class="q-pa-md">
      <q-input
        inverted-light
        color="grey-12"
        rows="7"
        type="textarea"
        float-label="Notes"
        :max-height="100"
        :value="studentForm.notes"
        @keyup.stop="updateStudentForm({ field: 'notes', value: $event.target.value })"
      />
    </q-field>
  </div>
</template>

<style>
</style>
